import { lazy } from 'react';
import { Switch } from 'react-router-dom';
import { AdminRoute, Route } from '@client/components/common/Route';

const VenuesEditLoader = lazy(() => import('./Venues/Edit'));
const VenuesProfileLoader = lazy(() => import('@client/components/Main/Profiles/Venue'));
const VenueShowsLoader = lazy(() => import('./Venues/Shows'));

export default ({ pathname }) => (
  <Switch>
    <AdminRoute
      exact
      path="/hosts/:venueId/edit"
      load={VenuesEditLoader}
    />

    <Route
      exact
      path="/hosts/:venueId"
      load={VenuesProfileLoader}
      key={pathname}
    />

    <Route
      exact
      path="/hosts/:venueId/shows"
      load={VenueShowsLoader}
      key={pathname}
    />
  </Switch>
);
